import { useContext, useMemo } from "react";

import Table from "components/Table";
import TableContext from "context/table/tableContext";
import {
    FILTER_NAMES,
    ID_TYPE,
    TABLE_NAMES,
    TABLE_NAMES_WITH_FILTERS,
    TRUE,
    usePermissions
} from "shared";

import { Role, UserDetailsData } from "./types";

const Permissions = () => {
    const { detailsData } = useContext(TableContext);

    const { isReadRoleNotAllowed } = usePermissions();

    const { roles }: UserDetailsData = detailsData;

    const ids = roles.map(({ id }: Role) => id).join(",");

    const innerTableQueryParams = useMemo(
        () => ({
            [FILTER_NAMES.IncludeStatic]: TRUE,
            [FILTER_NAMES.Id]: ids
        }),
        [ids]
    );

    return (
        <Table
            name={TABLE_NAMES.Permissions}
            nameForFilters={TABLE_NAMES_WITH_FILTERS.Permissions}
            hasNoPermissionToRead={isReadRoleNotAllowed}
            isInnerTable
            isNotSelectable
            hasNoPagination
            hasLocalFiltering
            idType={ID_TYPE.Id}
            innerTableQueryParams={innerTableQueryParams}
            fixedColumnWidth={180}
        />
    );
};

export default Permissions;
